export default __webpack_public_path__ + "static/media/units_white_icon.a0711f1f.svg";